import { c as _c } from "react/compiler-runtime";
import { cn } from '../../../../../../shared/cn';
import { P2 } from '../../../../../typography/Paragraph';
type MarkdownRenderRuntimeTimeErrorProps = {
  description: string;
  message: string;
  className?: string;
};
export function MarkdownRenderRuntimeTimeError(t0) {
  const $ = _c(9);
  const {
    description,
    message,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("custom-scrollbar text-contentSecondary", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="h-2" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description || $[4] !== message) {
    t3 = <P2 className="text-contentRed">{description}{t2}{message}</P2>;
    $[3] = description;
    $[4] = message;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}